/**
 * Map API product rows to the inventory import Excel column shape.
 */
export function mapProductsToImportRows(products) {
  return (products || []).map((p) => {
    const brand =
      p?.brandId?.brandName ||
      p?.brandId?.name ||
      p?.brandName ||
      "";
    const category =
      p?.categoryId?.categoryName ||
      p?.categoryId?.name ||
      p?.categoryName ||
      "";

    let retailStock = p?.retailInitialStock;
    let storeStock = p?.storeInitialStock;
    const stockArray = Array.isArray(p?.stockArray) ? p.stockArray : [];
    if (stockArray.length > 0) {
      const withRetail = stockArray.filter(
        (s) =>
          s?.retailInitialStock != null || s?.totalRetailInitialStock != null
      );
      const withStore = stockArray.filter(
        (s) =>
          s?.storeInitialStock != null || s?.totalStoreInitialStock != null
      );
      const latestRetail = withRetail[withRetail.length - 1];
      const latestStore = withStore[withStore.length - 1];
      if (latestRetail) {
        retailStock =
          latestRetail.totalRetailInitialStock ??
          latestRetail.retailInitialStock ??
          retailStock;
      }
      if (latestStore) {
        storeStock =
          latestStore.totalStoreInitialStock ??
          latestStore.storeInitialStock ??
          storeStock;
      }
    }

    return {
      "Product Name": p?.productName || "",
      Brand: brand,
      Category: category,
      Price: p?.retailPrice ?? p?.discountPrice ?? "",
      Quantity: p?.quantity ?? "",
      "Product Type": p?.productType || "",
      Unit: p?.unit || "",
      HSN: p?.hsn || "",
      "Initial Stock (Retail)":
        retailStock === undefined || retailStock === null || retailStock === ""
          ? ""
          : retailStock,
      "Initial Stock (Store Consumption)":
        storeStock === undefined || storeStock === null || storeStock === ""
          ? ""
          : storeStock,
    };
  });
}

/**
 * Map API service rows to the services import Excel column shape.
 */
export function mapServicesToImportRows(services) {
  return (services || []).map((s) => ({
    "Service Name": s?.serviceName || "",
    Category: s?.categoryName || s?.category || "",
    Duration: s?.duration ?? "",
    Amount: s?.amount ?? "",
    Colour: s?.colour || s?.color || "",
    "SAC Code": s?.sacCode || "",
  }));
}
